// const constant = {
//   // LocalStorage Keys
//   authToken: "auth-token", // Token key for authentication
//   currentUser: "current-user", // User details
//   userRoleKey: "user-role", // User role key
//   appSettings: "app-settings", // Application settings

//   // API URLs
//   // api: "http://localhost:8002/api/",
//   // url: "http://localhost:8002/",

//   // Uncomment the relevant API URLs for production
//   // api: "http://api51.peascom.ma/api/",
//   // url: "http://api51.peascom.ma/",

//    api: "https://api5.peascom.ma/api/",
//   url: "https://api5.peascom.ma/",

//   SupportApi: "https://api.peascom.ma/api/",
//   SupportUrl: "https://api.peascom.ma/",

//   // 💼 Accounting App (Comptable)

//   // accountingApi: "http://localhost:8051/api/",
//   // accountingUrl: "http://localhost:8051/",

//   accountingApi: "http://api51.peascom.ma/api/",
//   accountingUrl: "http://api51.peascom.ma/api/",
// };

// export default constant;
const constant = {
  // ======================
  // 🔐 LocalStorage Keys
  // ======================
  authToken: "auth-token",
  currentUser: "current-user",
  userRoleKey: "user-role",
  appSettings: "app-settings",

  // ======================
  // 🌍 Main APIs
  // ======================
  // api: "http://localhost:8050/api/",
  // url: "http://localhost:8050/",

  api: "https://api.charkpoulet.ma/api/",
  url: "https://api.charkpoulet.ma/",

  SupportApi: "https://api.peascom.ma/api/",
  SupportUrl: "https://api.peascom.ma/",

  // ======================
  // 💼 Accounting App (Comptable)
  // ======================
  accountingApi: "https://api51.peascom.ma/api/",
  accountingUrl: "https://api51.peascom.ma/api/",

  // ======================
  // 🏢 Management App
  // ======================
  managementAppUrl: "https://app5.peascom.ma",

  // ======================
  // 📊 Accounting App (External)
  // ======================
  accountingAppUrl: "https://app51.peascom.ma",
};

export default constant;
